import React, { useEffect, useState } from "react";
import "./CallcentralLogo.scss"
import logoLight from "../../../assets/images/logo/nserix-primary.svg";
import logoDark from "../../../assets/images/logo/nserix-dark.svg";

export const CallcentralLogo: React.FC = () => {
  // document.body's class is the source of truth the app's theme toggle
  // already writes to (see Header.tsx/Settings.tsx/AppLayout.tsx), so read it
  // directly and watch it rather than depending on the DarkModeContext, which
  // isn't reliably kept in sync with it on initial page load.
  const [isDarkMode, setIsDarkMode] = useState(
    document.body.classList.contains("dark-theme")
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDarkMode(document.body.classList.contains("dark-theme"));
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);

  return (
    <div className="logo-wrapper">
                <img
                  className="callcentral-logo"
                  src={isDarkMode ? logoDark : logoLight}
                  alt="Nserix"
                />
              </div>
  );
};
